export default "__VITE_ASSET__BNUoxSMh__"